/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import appSettings from '../../../../config/appSettings';

const types = [
    {
        type: 'personal',
        label: 'Personal Customer',
    },
    {
        type: 'ltd',
        label: 'Limited Company',
    },
];
const styles = ({ spacing: { unit } }) => ({
    root: {
        padding: unit * 2,
    },
    button: {
        marginRight: unit * 2,
    },
});

function ApplicationType(props) {
    return appSettings.onlyPersonalCustomer
        ? ''
        : (
            <div className={props.classes.root}>
                <Typography variant="subheading" gutterBottom>
                    You are applying as:
                </Typography>
                {types.map(item => (
                    <Button
                        key={item.type}
                        variant="raised"
                        color={props.applicationType === item.type ? 'primary' : 'default'}
                        className={props.classes.button}
                        onClick={() => props.setApplicationType(item.type)}
                    >
                        {item.label}
                    </Button>
                ))}
            </div>
        );
}

ApplicationType.propTypes = {
    classes: PropTypes.object.isRequired,
    applicationType: PropTypes.string.isRequired,
    setApplicationType: PropTypes.func.isRequired,
};

export default withStyles(styles)(ApplicationType);



// WEBPACK FOOTER //
// ./src/app/FormStepper/QuickQuote/components/ApplicationType.js